import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

function CourseFees() {
  return (
    <>
      <Header />
      
      <main className="main" style={{ background: 'linear-gradient(135deg, #FDFCFE 0%, #FAF8FC 50%, #F5EBFA 100%)', minHeight: '100vh' }}>
        {/* Hero Section */}
        <section style={{
          background: 'linear-gradient(to bottom, rgba(15, 23, 42, 0.7) 0%, rgba(30, 41, 59, 0.8) 100%), url(/assets/img/dtk4.jpg)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundAttachment: 'fixed',
          minHeight: '65vh',
          display: 'flex',
          alignItems: 'center',
          position: 'relative',
          overflow: 'hidden'
        }}>
          {/* Animated Pattern Overlay */}
          <div style={{
            content: '',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundImage: 'url("data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' viewBox=\'0 0 100 100\' fill=\'rgba(255,255,255,0.03)\'%3E%3Ccircle cx=\'25\' cy=\'25\' r=\'1\'/%3E%3Ccircle cx=\'75\' cy=\'75\' r=\'1.5\'/%3E%3C/svg%3E")',
            backgroundSize: '80px 80px',
            backgroundRepeat: 'repeat',
            animation: 'float 20s ease-in-out infinite'
          }}></div>
          
          {/* Gradient Border Bottom */}
          <div style={{
            position: 'absolute',
            bottom: 0,
            left: 0,
            right: 0,
            height: '5px',
            background: 'linear-gradient(90deg, #B17ACC 0%, #7B3F9E 50%, #B17ACC 100%)',
            backgroundSize: '200% 100%',
            animation: 'shimmer 3s ease-in-out infinite'
          }}></div>
          
          <div className="container" style={{ position: 'relative', zIndex: 2, padding: '80px 20px' }}>
            <div className="row justify-content-center text-center">
              <div className="col-lg-8">
                {/* Animated Badge */}
                <div style={{
                  display: 'inline-block',
                  backgroundColor: 'rgba(123, 63, 158, 0.2)',
                  backdropFilter: 'blur(10px)',
                  padding: '12px 30px',
                  borderRadius: '50px',
                  marginBottom: '30px',
                  border: '2px solid rgba(123, 63, 158, 0.4)',
                  boxShadow: '0 4px 20px rgba(123, 63, 158, 0.2)'
                }}>
                  <span style={{ 
                    color: '#e0d9e4ff', 
                    fontSize: '0.9rem', 
                    fontWeight: '700', 
                    letterSpacing: '2px',
                    textShadow: '0 0 10px rgba(123, 63, 158, 0.5)'
                  }}>
                    💰 COURSE FEES
                  </span>
                </div>
                
                <h1 style={{ 
                  fontSize: '4.5rem', 
                  fontWeight: '800',
                  color: 'white',
                  marginBottom: '30px',
                  lineHeight: '1.1',
                  letterSpacing: '-2px',
                  textShadow: '0 4px 30px rgba(0,0,0,0.5), 0 0 60px rgba(123, 63, 158, 0.2)'
                }}>
                  Course Fees
                </h1>
                
                {/* Decorative Line */}
                <div style={{
                  width: '150px',
                  height: '6px',
                  background: 'linear-gradient(90deg, transparent, #B17ACC, transparent)',
                  margin: '0 auto 35px',
                  borderRadius: '10px',
                  boxShadow: '0 0 20px rgba(123, 63, 158, 0.5)'
                }}></div>
                
                <p style={{
                  fontSize: '1.4rem',
                  color: 'rgba(255,255,255,0.95)',
                  maxWidth: '700px',
                  margin: '0 auto',
                  lineHeight: '1.8',
                  textShadow: '0 2px 15px rgba(0,0,0,0.3)',
                  fontWeight: '300'
                }}>
                  Transparent pricing for quality education
                </p>
              </div>
            </div>
          </div>
          
          <style>{`
            @keyframes float {
              0%, 100% { transform: translateY(0px); }
              50% { transform: translateY(-20px); }
            }
            @keyframes shimmer {
              0% { background-position: 200% 0; }
              100% { background-position: -200% 0; }
            }
          `}</style>
        </section>

        {/* Content Section */}
        <section id="course-fees" className="section" style={{ padding: '80px 0' }}>
          <div className="container" data-aos="fade-up">
            
            {/* Introduction */}
            <div className="row justify-content-center mb-5">
              <div className="col-lg-10">
                <div className="p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  <h2 style={{ 
                    fontSize: '2.5rem', 
                    fontWeight: '700', 
                    color: '#1e293b',
                    marginBottom: '25px'
                  }}>
                    Adult Course Fees
                  </h2>
                  <p style={{ 
                    fontSize: '1.1rem', 
                    color: '#475569', 
                    lineHeight: '1.8',
                    marginBottom: 0
                  }}>
                    At DTK College, we want to encourage people to learn and develop to the best of their abilities. We understand that financial matters can occasionally prevent them from doing so. We have many <strong style={{ color: '#7B3F9E' }}>FREE courses</strong> available to support learners with their studies and training.
                  </p>
                </div>
              </div>
            </div>

            {/* Course Fees Details */}
            <div className="row justify-content-center mb-5">
              <div className="col-lg-10">
                <div className="p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  <h3 style={{ 
                    fontSize: '2rem', 
                    fontWeight: '700', 
                    color: '#1e293b',
                    marginBottom: '25px',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '12px'
                  }}>
                    <span style={{ fontSize: '1.8rem' }}>💳</span> Course Fees
                  </h3>
                  <div style={{ color: '#475569', fontSize: '1.05rem', lineHeight: '1.8' }}>
                    <p>The course fees can be viewed on the course information pages of the website, showing the fees payable depending on age. Where courses include an exam fee, it is for one sitting only. If students need to re-take an exam, then they will have to pay an additional fee.</p>
                    <p>All fees shown apply to people aged 19 or over, who have been resident in the UK or in another country in the EEA for the last three years or more.</p>
                    <p>For some courses, there are additional fees which are payable later or at enrolment and cover extra costs associated with the course, such as materials, trips etc. These will be discussed with you.</p>
                    <p style={{ 
                      backgroundColor: '#fef3c7', 
                      padding: '20px', 
                      borderRadius: '12px',
                      borderLeft: '4px solid #f59e0b',
                      marginTop: '20px'
                    }}>
                      <strong>Important:</strong> Fees are payable on enrolment and failure to pay the fees could result in the learner being withdrawn from the course and the fees being recovered through our External Debt Collection agency.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Before You Start */}
            <div className="row justify-content-center mb-5">
              <div className="col-lg-10">
                <div className="p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  <h3 style={{ 
                    fontSize: '2rem', 
                    fontWeight: '700', 
                    color: '#1e293b',
                    marginBottom: '25px',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '12px'
                  }}>
                    <span style={{ fontSize: '1.8rem' }}>✅</span> Before You Start
                  </h3>
                  <p style={{ fontSize: '1.1rem', color: '#475569', marginBottom: '25px' }}>
                    Please make sure you are eligible for funding before starting your enrolment.
                  </p>
                  <h4 style={{ fontSize: '1.4rem', fontWeight: '600', color: '#7B3F9E', marginBottom: '20px' }}>
                    Eligibility Requirements
                  </h4>
                  <ul style={{ color: '#475569', fontSize: '1.05rem', lineHeight: '2', paddingLeft: '25px' }}>
                    <li>Aged 19 or over as of 31/8/24</li>
                    <li>Living in England</li>
                    <li>Have lived in the UK/EU/EEA for at least 3 years*</li>
                    <li>Not completed any part of the course before</li>
                  </ul>
                  <div style={{ 
                    backgroundColor: '#FDFCFE', 
                    padding: '20px', 
                    borderRadius: '12px',
                    marginTop: '20px',
                    fontSize: '0.95rem',
                    color: '#475569'
                  }}>
                    <p style={{ marginBottom: '10px' }}><strong>*</strong> EEA nationals will need to have obtained either pre settlement or settled status and provide evidence of this.</p>
                    <p style={{ marginBottom: '10px' }}><strong>*</strong> If you are receiving benefits (e.g. JSA, ESA, Universal Credit (UC), Housing benefits etc. please bring evidence of this).</p>
                    <p style={{ marginBottom: 0 }}><strong>*</strong> Assessment will be carried out using an online tool or paper-based paperwork which meets the national literacy and numeracy standards.</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Free Courses */}
            <div className="row justify-content-center mb-5">
              <div className="col-lg-10">
                <div className="p-5 shadow-lg" style={{ 
                  backgroundColor: '#F5EBFA',
                  borderRadius: '24px',
                  border: '2px solid #B17ACC'
                }}>
                  <h3 style={{ 
                    fontSize: '2rem', 
                    fontWeight: '700', 
                    color: '#7B3F9E',
                    marginBottom: '25px',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '12px'
                  }}>
                    <span style={{ fontSize: '1.8rem' }}>🎓</span> Free Courses
                  </h3>
                  <div style={{ color: '#1e293b', fontSize: '1.05rem', lineHeight: '1.8' }}>
                    <p style={{ fontWeight: '600', fontSize: '1.15rem' }}>
                      If you are aged 19+ and have not previously gained a GCSE grade C/4 or higher, you will be fully funded if you study for a qualification in English or maths, up to and including Level 2.
                    </p>
                    <p style={{ fontWeight: '600', fontSize: '1.15rem' }}>
                      If you are unemployed looking for work or earn less than £25,642.50 you can study our English courses for free.
                    </p>
                    <p style={{ marginTop: '25px', marginBottom: '20px' }}>
                      For courses marked with an asterisk, DTK College does not charge any compulsory fees if you are studying at Level 2 or below and you are aged 19 years or over and a student in one of the following categories:
                    </p>
                    <ul style={{ paddingLeft: '25px', lineHeight: '2' }}>
                      <li>Students in receipt of Job Seeker's Allowance (JSA)</li>
                      <li>Students in receipt of Employment & Support Allowance (ESA)</li>
                      <li>Students in receipt of Universal Credit whose take-home pay as recorded on their Universal Credit statement (disregarding benefits) is less than £892 a month (learner is sole adult in their benefit claim) or £1437 a month (learner has a joint benefit claim with their partner). The learner wants to be employed, and the College is satisfied that the learning directly relates to their employment prospects</li>
                      <li>Students who are in receipt of any state benefits not listed above and whose income (disregarding benefits and UC payments) is less than £892 a month (learner is sole adult in their benefit claim) or £1437 a month (learner has a joint benefit claim with their partner) and who want to improve their prospects of employment. The College must be satisfied that the learning is directly related to both the individual's employment prospects and the needs of the local labour market. Students must state the name of the benefit</li>
                      <li>Students aged 19-23 who do not currently hold a full Level 2 taking an Entry Level or Level 1 course and wish to progress to a legal entitlement at Level 2 (not available in the workplace)</li>
                      <li>Students aged 19-23 who do not currently hold a full Level 3 taking a legal entitlement qualification at Level 3 (classroom or workplace)</li>
                      <li>Students aged 19+ who have not previously attained a GCSE grade A*-C or 4-9 in Maths or English taking Functional Skills or GCSE Maths or English, or other Maths and English qualifications which are part of the legal entitlements at Entry Level, Level 1, or Level 2, if they have been assessed to be at a lower level than the aim they are studying</li>
                    </ul>
                    <p style={{ 
                      backgroundColor: '#d1fae5', 
                      padding: '15px', 
                      borderRadius: '8px',
                      marginTop: '20px',
                      fontSize: '0.95rem'
                    }}>
                      Assessment will be carried out using an online tool or paper-based paperwork which meets the national literacy and numeracy standards.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* National Living Wage */}
            <div className="row justify-content-center mb-5">
              <div className="col-lg-10">
                <div className="p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  <h3 style={{ 
                    fontSize: '2rem', 
                    fontWeight: '700', 
                    color: '#1e293b',
                    marginBottom: '25px',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '12px'
                  }}>
                    <span style={{ fontSize: '1.8rem' }}>💷</span> National Living Wage and Low Wage Rates
                  </h3>
                  <p style={{ fontSize: '1.05rem', color: '#475569', marginBottom: '20px' }}>
                    These rates are for the National Living Wage and the National Minimum Wage from April 2026:
                  </p>
                  <div className="row g-4">
                    <div className="col-md-6">
                      <div style={{ 
                        backgroundColor: '#f8fafc', 
                        padding: '25px', 
                        borderRadius: '12px',
                        border: '1px solid #e2e8f0',
                        textAlign: 'center'
                      }}>
                        <div style={{ fontSize: '2.5rem', fontWeight: '700', color: '#7B3F9E', marginBottom: '10px' }}>£10.85</div>
                        <div style={{ color: '#475569', fontSize: '1.05rem' }}>18-20 year old</div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div style={{ 
                        backgroundColor: '#F5EBFA', 
                        padding: '25px', 
                        borderRadius: '12px',
                        border: '2px solid #B17ACC',
                        textAlign: 'center'
                      }}>
                        <div style={{ fontSize: '2.5rem', fontWeight: '700', color: '#7B3F9E', marginBottom: '10px' }}>£12.71</div>
                        <div style={{ color: '#1e293b', fontSize: '1.05rem', fontWeight: '600' }}>National Living Wage<br/>(21 and over)</div>
                      </div>
                    </div>
                  </div>
                  <div style={{ 
                    backgroundColor: '#fef3c7', 
                    padding: '20px', 
                    borderRadius: '12px',
                    marginTop: '25px',
                    borderLeft: '4px solid #f59e0b'
                  }}>
                    <h4 style={{ fontSize: '1.2rem', fontWeight: '600', color: '#92400e', marginBottom: '10px' }}>
                      Low Wage Definition:
                    </h4>
                    <p style={{ color: '#475569', fontSize: '1.05rem', marginBottom: 0 }}>
                      You are defined as having a low wage if you earn less than <strong>£26, 227.50 (GLA)</strong> annual gross salary.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Refunds */}
            <div className="row justify-content-center mb-5">
              <div className="col-lg-10">
                <div className="p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  <h3 style={{ 
                    fontSize: '2rem', 
                    fontWeight: '700', 
                    color: '#1e293b',
                    marginBottom: '25px',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '12px'
                  }}>
                    <span style={{ fontSize: '1.8rem' }}>↩️</span> Refunds
                  </h3>
                  <p style={{ fontSize: '1.05rem', color: '#475569', lineHeight: '1.8' }}>
                    All course fees and additional fees are non-returnable from two weeks prior to the course start date unless it is later cancelled by DTK College or is oversubscribed. If any course is cancelled or already full, you will receive a full refund.
                  </p>
                </div>
              </div>
            </div>

            {/* University Level */}
            <div className="row justify-content-center mb-5">
              <div className="col-lg-10">
                <div className="p-5 shadow-lg" style={{ 
                  backgroundColor: '#fff',
                  borderRadius: '24px',
                  border: '1px solid #e2e8f0'
                }}>
                  <h3 style={{ 
                    fontSize: '2rem', 
                    fontWeight: '700', 
                    color: '#1e293b',
                    marginBottom: '25px',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '12px'
                  }}>
                    <span style={{ fontSize: '1.8rem' }}>🎓</span> University Level
                  </h3>
                  <p style={{ fontSize: '1.05rem', color: '#475569', lineHeight: '1.8' }}>
                    If you are applying through UCAS, you can apply for loans and grants via Student Finance England at{' '}
                    <a 
                      href="https://www.gov.uk/student-finance" 
                      target="_blank" 
                      rel="noopener noreferrer"
                      style={{ color: '#7B3F9E', fontWeight: '600', textDecoration: 'none' }}
                    >
                      www.gov.uk/student-finance
                    </a>
                  </p>
                </div>
              </div>
            </div>

            {/* Call to Action */}
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="text-center p-5 shadow-lg" style={{ 
                  background: 'linear-gradient(135deg, #7B3F9E 0%, #6B2F8E 100%)',
                  borderRadius: '24px',
                  color: 'white'
                }}>
                  <h2 style={{ 
                    fontSize: '2.8rem', 
                    fontWeight: '700', 
                    marginBottom: '20px',
                    textShadow: '0 2px 10px rgba(0,0,0,0.2)'
                  }}>
                    Let your dreams take a flight!
                  </h2>
                  <p style={{ 
                    fontSize: '1.15rem', 
                    maxWidth: '600px', 
                    margin: '0 auto 30px',
                    opacity: '0.95',
                    lineHeight: '1.8'
                  }}>
                    Ready to start your learning journey? Get in touch with us today to discuss your options and find the perfect course for your goals.
                  </p>
                  <a 
                    href="/contact" 
                    style={{
                      display: 'inline-block',
                      backgroundColor: 'white',
                      color: '#7B3F9E',
                      padding: '15px 40px',
                      borderRadius: '50px',
                      fontSize: '1.1rem',
                      fontWeight: '600',
                      textDecoration: 'none',
                      boxShadow: '0 4px 15px rgba(0,0,0,0.2)',
                      transition: 'transform 0.3s ease'
                    }}
                    onMouseOver={(e) => e.target.style.transform = 'translateY(-2px)'}
                    onMouseOut={(e) => e.target.style.transform = 'translateY(0)'}
                  >
                    Make an Appointment
                  </a>
                </div>
              </div>
            </div>

          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}

export default CourseFees;
